var FunderAPI = require('../../../../common/api').Funder;
var SchemeAPI = require('../../../../common/api').Scheme;

module.exports = function($scope) {
  var vm = this;
  vm.schemes = [];
  vm.seekingPublicFunding = true;
  vm.seekingTrustFunding = true;
  vm.specificTrustForFunding = "";
  vm.schemeMatchedFunding = "";
  vm.createApplication = true;

  vm.searchFunders = function(filter) {
    return FunderAPI.searchFunders(filter, "FunderLabelView", 10, 1);
  }

  vm.loadFunders = function()
  {
    //Temp 1000 size until typeahead fully worked out
    FunderAPI.searchFunders("", "FunderLabelView", 1000, 1).then(function(result) {
      vm.funders = result.results;
    });
  }

  vm.getSchemes = function (selected) {
    vm.specificTrustForFundingId = selected.originalObject.id;
    FunderAPI.GetSchemes(vm.specificTrustForFundingId, false, 3, null, "FunderSchemesDropDownView").then(function(result) {
      vm.schemes = result;
    })
  }

  vm.toggle = function() {
    vm.createApplication = !vm.createApplication;
  }

  $scope.close = function () {
    $scope.closeThisDialog({action:"close"});
  }

  vm.loadFunders();

  vm.submit = function() {
    $scope.closeThisDialog({
      projectTitle: vm.projectTitle,
      seekingPublicFunding: vm.seekingPublicFunding,
      seekingTrustFunding: vm.seekingTrustFunding,
      specificTrustForFundingId: vm.specificTrustForFundingId,
      specificSchemeUnderTrustId: vm.specificSchemeUnderTrustId
    })
  }
}
